import {DocumentType} from "../enums/documentType";
import StringHelpers from "../helpers/stringHelpers";
import docTypePartialMixin from "./docTypePartialMixin";

export default {
  mixins: [StringHelpers, docTypePartialMixin],
  props: {
    document: {
      type: Object
    },
    docType: {
      type: Number as () => DocumentType,
      default: () => DocumentType.document
    }
  },
  computed: {
    docTypeIsApplication() {
      return this.docType === DocumentType.application
    }
  }
};